import { Dashboard } from './Dashboard';

export const DashboardConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      id: 'dashboard.main',
      path: 'dashboard',
      element: <Dashboard />,
    },
  ],
}
